module.exports = ".logo{width:200px}.avatar{height:200px;width:200px}"